import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["themeWrapper"]

  setLightTheme() {
    this.themeWrapperTarget.dataset.colorScheme = "light"
  }
  setDarkTheme() {
    this.themeWrapperTarget.dataset.colorScheme = "dark"
  }
}
